import React from "react";

export default function ClientFAQPage() {
  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-3xl font-bold text-indigo-700 mb-6">❓ Frequently Asked Questions</h1>

      <div className="space-y-6 text-gray-800">
      <div>
          <h2 className="text-lg font-semibold">Where do I complete the credit counseling/debtor education course?</h2>
          <p>
            There are many agencies that you can use to complete the courses and get the certificate,
            I recommend the company MoneySharp where you can take the course at <a 
              href="https://moneysharp.org" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-indigo-600 underline"
            >
              moneysharp.org
            </a>.
            Use attorney code <strong><u>Cisowski</u></strong> when you register and they forward the certificate to me.
          </p>
        </div>
        <div>
          <h2 className="text-lg font-semibold">What documents do I need to provide?</h2>
          <p>
            You will be asked to upload items like paystubs, tax returns, bank statements,
            identification, and other documents specific to your case. You can see your document
            checklist on the dashboard.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold">What if I don’t have access to a printer or scanner?</h2>
          <p>
            You can use your phone to take clear photos of your documents and upload them directly
            through the client portal.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold">How do I know when my documents are accepted?</h2>
          <p>
            Your dashboard will show the status of each document. You will also receive an email
            when all documents have been reviewed and accepted.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold">What happens if a document is rejected?</h2>
          <p>
            If a document is rejected, you’ll receive an email with the reason. You can then upload a
            new version from the document center.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold">Who can I contact with questions?</h2>
          <p>
            Please reach out to your attorney directly by phone or email. If you need help with the
            portal, feel free to call our office at (423) 342-4722.
          </p>
        </div>
      </div>
    </div>
  );
}
